import { createStyles, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const styles = (theme: Theme) =>
  createStyles({
    field: {
      '&:nth-child(2)': {
        marginRight: theme.spacing(1),
        marginLeft: theme.spacing(1),
      },
      '& input': {
        height: '50px',
      },
    },
    durationWrapper: {
      display: 'flex',
      flexDirection: 'column',
    },
    intervalWrapper: {
      display: 'flex',
    },
    checkbox: {
      marginRight: theme.spacing(2),
    },
  });

export const useStyles = makeStyles(styles);
